import { Button, Card, Modal } from '@playerbase/ui';

// Confirmation step for the "Dismiss" action on a pattern card. Mirrors
// the disable-confirm-modal pattern used elsewhere in the portal: small
// Modal, Card body, ghost Cancel + danger primary, busy flag suppresses
// dismissal while the RPC is in flight. Errors render inline above the
// footer rather than via toast, matching the rest of the surface.

interface DismissPatternConfirmModalProps {
  open: boolean;
  patternTitle: string;
  patternId: string;
  busy: boolean;
  error: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export function DismissPatternConfirmModal({
  open,
  patternTitle,
  patternId,
  busy,
  error,
  onConfirm,
  onCancel,
}: DismissPatternConfirmModalProps): JSX.Element {
  const labelId = `dismiss-pattern-${patternId}`;
  return (
    <Modal
      open={open}
      onClose={onCancel}
      labelledById={labelId}
      busy={busy}
      size="sm"
    >
      <Card>
        <Card.Header>
          <Card.Title id={labelId}>Dismiss pattern</Card.Title>
          <Card.Description>
            Dismiss <strong>{patternTitle}</strong>? It will leave the four
            buckets. You can bring it back later.
          </Card.Description>
        </Card.Header>
        {error !== null && (
          <Card.Content>
            <p className="text-sm text-danger-text">{error}</p>
          </Card.Content>
        )}
        <Card.Footer>
          <Button variant="ghost" onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button variant="danger" onClick={onConfirm} disabled={busy}>
            {busy ? 'Dismissing…' : 'Dismiss pattern'}
          </Button>
        </Card.Footer>
      </Card>
    </Modal>
  );
}
